// extracted by mini-css-extract-plugin
export default {"root":"DetailSection_root__kckZo","heading":"DetailSection_heading__-x1Kh textBodyMd","value":"DetailSection_value__MHKu9 textBodyMd"};